export let props = {}
export let model = {
  hasClick: false
}
export let computed = {}
